import { $, $$, rect } from '@utils/dom';
import ResizeOrientation from '@utils/resize';

class SnappySvg {
  constructor(el) {
    this.el = el;
    this.parent = this.el.parentElement;
    this.svg = $('svg', this.el);
    this.rects = [ ...$$('rect', this.el) ];

    this._resize = this._resize.bind(this);

    // stop here if element has no parent element
    if(!this.parent) return;

    this.init();
  }

  init() {
    this._bindEvents();
    this._resize();
  }

  destroy() {
    this._unbindEvents();

    this.el = null;
    this.emitter = null;
    this.rects = null;

    this._ro = null;
  }

  _bindEvents() {
    if(this.rects.length) ResizeOrientation.add(this._resize);
  }

  _unbindEvents() {
    if(this.rects.length) ResizeOrientation.remove(this._resize);
  }

  _resize() {
    let { width, height } = rect(this.parent);

    // round dimensions values
    width = parseInt(width);
    height = parseInt(height);

    // transform SVG viewBox and dimension
    this.svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
    this.svg.setAttribute("width", width);
    this.svg.setAttribute("height", height);

    // transform each <rect/>
    this.rects.forEach((r) => {
        const offset = r.getAttribute("stroke-width");
        const scale = r.getAttribute('vector-effect') === 'non-scaling-stroke' ? rect(r).width / r.getBBox().width : 1;
        r.setAttribute("width", width - offset);
        r.setAttribute("height", height - offset);
        r.setAttribute("x", offset / 2);
        r.setAttribute("y", offset / 2);
        r.style.setProperty('--scale', scale);
        r.style.setProperty('--length', `${r.getTotalLength()}px`);
        r.style.setProperty('--height', `${height - offset}px`);
        r.style.setProperty('--width', `${width - offset}px`);
    })
  }
}

export default SnappySvg;
